import type { CanonicalSearchLoad } from '@numeo/types'
import type { ResponseFilter } from '../types/state'

/** How long a load the broker took off the board keeps its row on the board, reading "Cancelled",
 *  before it moves to Archived. The server has archived it already; this is only how long it lingers. */
export const CANCELLED_ROW_LINGER_MS = 60_000

/** The header's "N Results" is the server's total for the live board with no search typed in. A live
 *  event moves that total only while the tab shows exactly that view. */
export const countsLiveBoard = (tab: { responseFilter: ResponseFilter; loadsSearchQuery: string }): boolean =>
    tab.responseFilter === 'all' && tab.loadsSearchQuery.trim() === ''

/** A pushed update that cancels a row and archives it. */
export const isArchivingCancellation = (updates: Partial<CanonicalSearchLoad>): boolean =>
    updates.emailStatus === 'load_cancelled' && Boolean(updates.deletedAt)
